(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(5719);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@storyblok/react/dist/storyblok-react.mjs
var storyblok_react = __webpack_require__(9036);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/blocks/Header.tsx + 23 modules
var Header = __webpack_require__(517);
// EXTERNAL MODULE: ./src/blocks/Footer.tsx + 1 modules
var Footer = __webpack_require__(189);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./src/components/elements/Copy/Copy.tsx
var Copy = __webpack_require__(8765);
// EXTERNAL MODULE: ./src/components/utils/focusStyle.ts
var focusStyle = __webpack_require__(1586);
;// CONCATENATED MODULE: ./public/icons/xsmall/Arrow-Thin-Right.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowThinRight = function SvgArrowThinRight(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.649 5.646 13.002 10 8.65 14.354l-.708-.707L11.588 10 7.94 6.354l.708-.708Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var Arrow_Thin_Right = (SvgArrowThinRight);
// EXTERNAL MODULE: ./src/components/modules/Wrapper/Wrapper.tsx + 1 modules
var Wrapper = __webpack_require__(8709);
;// CONCATENATED MODULE: ./src/components/modules/Breadcrumb/Breadcrumb.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: var(--max-width-page);\n  padding-top: var(--distance-static-l);\n  padding-bottom: var(--distance-static-l);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: var(--distance-static-3xs);\n  margin: 0;\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: var(--distance-static-3xs);\n  align-items: center;\n  list-style: none;\n  color: var(--color-text-dark-subdued);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  text-decoration: none;\n  color: currentColor;\n\n  &:hover {\n    color: var(--color-text-dark);\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  color: var(--color-text-dark);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: var(--icon-size-xxs);\n  height: var(--icon-size-xxs);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper.Wrapper).withConfig({
    componentId: "sc-b3f3f30d-0"
})(_templateObject());
var StyledList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-b3f3f30d-1"
})(_templateObject1());
var StyledItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b3f3f30d-2"
})(_templateObject2());
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b3f3f30d-3"
})(_templateObject3(), Copy/* copyBaseStyles */.jn, Copy/* copySizes.s */.Y4.s, focusStyle/* focusStyleDark */.x4);
var StyledText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b3f3f30d-4"
})(_templateObject4(), Copy/* copyBaseStyles */.jn, Copy/* copySizes.s */.Y4.s);
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(Arrow_Thin_Right).withConfig({
    componentId: "sc-b3f3f30d-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/modules/Breadcrumb/Breadcrumb.tsx



var Breadcrumb = function(param) {
    var items = param.items;
    var linkListLength = items.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        forwardedAs: "section",
        width: {
            laptop: "xl",
            tabletLandscape: "l"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            role: "navigation",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                itemScope: true,
                itemType: "https://schema.org/BreadcrumbList",
                children: items.map(function(item, index) {
                    var isLast = index === linkListLength - 1;
                    var contentIndex = "".concat(index + 1);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItem, {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        children: isLast ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                    itemProp: "name",
                                    children: item.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: contentIndex
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                    href: item.href,
                                    itemProp: "item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        itemProp: "name",
                                        children: item.label
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: contentIndex
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {})
                            ]
                        })
                    }, item.id);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/providers/SearchProvider.tsx
var SearchProvider = __webpack_require__(5321);
// EXTERNAL MODULE: ./src/providers/StoryProvider.tsx
var StoryProvider = __webpack_require__(4727);
// EXTERNAL MODULE: ./src/utils/search/propertyData.ts
var propertyData = __webpack_require__(5769);
;// CONCATENATED MODULE: ./pages/[...slug].tsx








var Home = function(_param) {
    var baseSlug = _param.baseSlug, props = (0,_object_without_properties/* default */.Z)(_param, [
        "baseSlug"
    ]);
    var contactModule = props.contactModule, breadcrumbPaths = props.breadcrumbPaths;
    var ref = props.navigation || {}, header = ref.header, footer = ref.footer;
    var story = (0,storyblok_react/* useStoryblokState */.f0)(props.story, {}, props.preview);
    var setSearchState = (0,SearchProvider/* useSearchState */.e)().setSearchState;
    var setStoryState = (0,StoryProvider/* useStoryState */.d)().setStoryState;
    var pageData = story === null || story === void 0 ? void 0 : story.content;
    var shouldAddContactModule = !!contactModule && !pageData.disabledGlobalContactModule;
    (0,react.useEffect)(function() {
        setSearchState({
            properties: (0,propertyData/* flatPropertiesDataConverter */.oG)(props.properties || []),
            propertiesPreview: props.propertiesPreview || null
        });
        setStoryState({
            preview: props.preview,
            baseSlug: baseSlug,
            pageLanguages: props.pageLanguages,
            alternates: story.alternates,
            marketConfig: props.marketConfig,
            story: story
        });
    }, [
        props.preview,
        props.properties,
        setSearchState,
        setStoryState,
        baseSlug,
        props.pageLanguages,
        story.alternates,
        story.full_slug,
        story,
        props.marketConfig,
        props.propertiesPreview, 
    ]);
    var _breadcrumb_display_name;
    var breadcrumb = breadcrumbPaths === null || breadcrumbPaths === void 0 ? void 0 : breadcrumbPaths.filter(function(item) {
        return item;
    }).map(function(item) {
        return {
            href: "/".concat(item.full_slug),
            label: (_breadcrumb_display_name = item.content.breadcrumb_display_name) !== null && _breadcrumb_display_name !== void 0 ? _breadcrumb_display_name : item.name,
            id: item.id
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!header && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* HeaderBlock */.V, {
                blok: header,
                baseSlug: baseSlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(storyblok_react/* StoryblokComponent */.Xj, {
                blok: story.content,
                story: story,
                contactModule: shouldAddContactModule && contactModule
            }),
            (breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb, {
                items: breadcrumb
            }),
            !!footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* FooterBlock */.r, {
                blok: footer
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);